<template>
	<div>
		<img src="../../../../static/assets/img/totoboLoader.gif" alt="">
	</div>
</template>

<script>
    export default {
        name: 'spinalLoader',
        data () {
            return {
                msg: ''
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/loader/spinalLoader.vue